import { render, staticRenderFns } from "./OperaAreasWindow.vue?vue&type=template&id=6d45f7d3&"
import script from "./OperaAreasWindow.vue?vue&type=script&lang=js&"
export * from "./OperaAreasWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports